<template>
  <div class="account-container">
    <!-- <div class="tabs"/> -->
    <div class="header">
      <div class="title">对账管理</div>
      <p class="red-notice in-header">注意：因系统升级，此页面部所统计的信息可能有误，如需导出汇总报表，请移步到【对账单导出】页面进行导出。</p>
    </div>
    <div class="content">
      <div class="time">
        <el-row :gutter="20">
          <el-col :span="1.5">
            <div class="label">对账日期</div>
          </el-col>
          <el-col :span="18">
            <cumstom-date-time-range @change="changeDateRange"/>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="shopType">
          <el-col :span="1.5">
            <div class="label">选择门店</div>
          </el-col>
          <el-col :span="1">
            <custom-select v-model="formEntity.selectedMerchantId" :list="shopList" :pageLoading="shopPageInfo.loading" @loadmore="queryShopList"/>
          </el-col>
        </el-row>
        <div class="export" v-if="[1, 3].includes(userRole)">
          <el-button class="export-btn" @click="toExportOrder">导出全部门店汇总对账单</el-button>
          <p>说明：数据精确到天，不区分时分秒</p>
        </div>
      </div>
      <div class="setting">
        <div class="tips">
          <div class="word">导出设置 <span>(结算信息包含费率、手续费、结算金额，每天上午5点可导出前一天的账单)</span></div>
          <div class='btn-group'>
            <el-button class="setting-btn" @click="goSettingHeader">设置表头</el-button>
            <el-button class="setting-btn" @click="doShowExportDialog">导出数据</el-button>
            <el-button class="setting-btn" @click="doShowExportDialog($event,true)">导出退款金额带负号的数据</el-button>
            <div @click="goShowExportDialog">导出记录</div>
          </div>
        </div>
        <section :class="{'edit-section': true, edit: isEdit}" v-loading="loading">
          <div class="item">
            <p class="title">表头设置</p>
            <div class="row">
              <div
                :class="{btn:true, active: item.checked}"
                v-for="(item, index) in tableHeader.detailHeader"
                :key="item.code"
                @click="doCheckedDetailHeader(index, item)">
                <span>{{ item.name }}</span>
                <div class="mark"><i class="el-icon-check"/></div>
              </div>
            </div>
          </div>
          <div class="item">
            <p class="title">汇总数据设置</p>
            <div class="row">
              <div
                :class="{btn:true, active: item.checked}"
                v-for="(item, index) in tableHeader.summaryHeader"
                :key="item.code"
                @click="doCheckedSummaryHeader(index, item)">
                <span>{{ item.name }}</span>
                <div class="mark"><i class="el-icon-check"/></div>
              </div>
            </div>
          </div>
          <div class="mask" v-if="!isEdit"/>
        </section>
        <div class="edit-btn-group">
          <el-button class="save-btn" @click="doSaveHeader" v-if="isEdit">保存</el-button>
          <el-button class="cancel-btn" @click="doCancelHeader" v-if="isEdit">取消</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      class="account-export-dialog-container"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :close-on-click-modal="false"
      append-to-body>
      <div class="header" slot="title">
        <p class="title">文件导出</p>
        <p class="tips">文件生成后将保留7天，超过时间将自动删除</p>
      </div>
      <div class="content" v-loading="tableLoading">
        <el-table
          :data="fileList"
          border
          style="width: 100%;">
          <el-table-column align="center" prop="createTime" label="生成时间" width="180"/>
          <el-table-column align="center" prop="fileName" label="文件名称" width="180"/>
          <el-table-column align="center" prop="statusName" label="状态"/>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <div style="display: flex;">
                <el-button size="mini" type="danger" @click="doDelete(scope.$index, scope.row)">删除</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  class="bs-btn"
                  :style="{visibility: scope.row.status === 1 ? 'visible' : 'hidden'}"
                  @click="doDownload(scope.$index, scope.row)">下载
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="page.count > 0"
            class="pagination"
            :page-size="page.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="page.count"
            :current-page="page.pageNo"
            @current-change="onChangeCurrentPage"/>
        </el-col>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryTableHeader, queryExcelList, deleteExcel, generateExcel, downLoadExcel, updateTableHeader, exportAllSummary,
} from '@/api/account';
import { queryShopList } from "@/api/merchant-info";
import CumstomDateTimeRange from './components/CustomDateTimeRange.vue';
import CustomSelect from '@/components/CustomSelect/index.vue';
import { formatDatehour } from "@/utils/index";

const fileStatus = {
  0: '生成中',
  1: '生成成功',
  2: '文件数据为空',
  3: '生成失败',
};

export default {
  name: 'account',
  components: {
    CumstomDateTimeRange,
    CustomSelect,
  },
  data() {
    return {
      activeTab: 0,
      loading: false,
      tableLoading: false,
      isEdit: false, // 是否可以编辑表头
      dialogVisible: false,
      tableHeader: {
        detailHeader: [],
        summaryHeader: [],
        id: '',
      },
      timer: null,
      fileList: [],
      shopList: [{ merchantId: '@', merchantName: '全部门店', checked: true }],
      shopPageInfo: {
        pageNo: 1,
        loading: false,
        finished: false,
        pageSize: 30,
      },
      formEntity: {
        selectedMerchantId: ['@'],
        dateTimeRange: [],
        startTime: "",
        endTime: "",
      },
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      shopType: 1,
      userRole: 1, // 用户角色： 0收银员，1店长，2后台管理员，2老板
    };
  },
  watch: {
    activeTab() {
      this.isEdit = false;
      this.queryTableHeader();
    },
  },
  methods: {
    // 获取门店列表
    queryShopList() {
      const { pageNo, finished, pageSize } = this.shopPageInfo;
      if (finished) return false;
      const params = {
        userName: "",
        merchantName: "",
        merchantId: "",
        pageNo,
        pageSize,
      };
      this.shopPageInfo.loading = true;
      return queryShopList(params).then((res) => {
        this.shopPageInfo.loading = false;
        if (res.data.error_code === 0) {
          const newList = res.data.data.list;
          this.shopList = [...this.shopList, ...newList];
          if (newList.length < pageSize) {
            this.shopPageInfo.finished = true;
          } else {
            this.shopPageInfo.pageNo += 1;
          }
        }
      });
    },
    goSettingHeader() {
      this.isEdit = true;
    },
    doCancelHeader() {
      this.isEdit = false;
      this.queryTableHeader();
    },
    doSaveHeader() {
      const params = {
        id: this.tableHeader.id,
        detailHeaderList: [],
        totalHeaderList: [],
      };
      this.tableHeader.detailHeader.forEach((v) => {
        if (v.checked) params.detailHeaderList.push(v.code);
      });
      this.tableHeader.summaryHeader.forEach((v) => {
        if (v.checked) params.totalHeaderList.push(v.code);
      });
      updateTableHeader(params).then((res) => {
        if (res.data.error_code === 0) {
          this.$message.success('保存成功！');
          this.isEdit = false;
          this.queryTableHeader();
        }
      });
    },
    doCheckedDetailHeader(index, item) {
      item.checked = !item.checked;
      this.tableHeader.detailHeader.splice(index, 1, item);
    },
    doCheckedSummaryHeader(index, item) {
      item.checked = !item.checked;
      this.tableHeader.summaryHeader.splice(index, 1, item);
    },
    doDownload(index, row) {
      downLoadExcel(row.id);
    },
    doDelete(index, row) {
      deleteExcel({ id: row.id }).then((res) => {
        if (res.data.error_code === 0) {
          this.$message.success('删除成功！');
          this.queryExcelList();
        }
      });
    },
    queryTableHeader() {
      this.loading = true;
      queryTableHeader().then((res) => {
        if (res.data.error_code === 0) {
          this.tableHeader.detailHeader = res.data.data.detailHeader;
          this.tableHeader.summaryHeader = res.data.data.totalHeader;
          this.tableHeader.id = res.data.data.id;
        }
        // 让用户可以更好的感受tab切换效果
        setTimeout(() => {
          this.loading = false;
        }, 100);
      });
    },
    changeDateRange(dateTimeRange) {
      this.formEntity.startTime = formatDatehour(dateTimeRange[0]);
      this.formEntity.endTime = formatDatehour(dateTimeRange[1]);
      // this.formEntity.dateTimeRange = dateTimeRange;
    },
    queryExcelList() {
      this.tableLoading = true;
      const param = Object.assign({
        exportType: this.activeTab,
      }, this.page);
      queryExcelList(param).then((res) => {
        if (res.data.error_code === 0) {
          // 如果所有文件状态都不是等待中，就取消轮训
          let isCancel = true;
          res.data.data.list.forEach((v) => {
            v.statusName = fileStatus[v.status];
            if (v.status === 0) isCancel = false;
          });
          if (isCancel) clearInterval(this.timer);
          this.fileList = res.data.data.list;
          this.page.count = res.data.data.total;
        }
        this.tableLoading = false;
      });
    },
    // 分页
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryExcelList();
    },
    generateExcel(isNew) {
      // 进入文件导出列表页面，先请求文件列表
      // this.queryExcelList();
      const excludeDetailList = [];
      const excludeTotalList = [];
      this.tableHeader.detailHeader.forEach((v) => {
        if (v.checked !== true) excludeDetailList.push(v.code);
      });
      this.tableHeader.summaryHeader.forEach((v) => {
        if (v.checked !== true) excludeTotalList.push(v.code);
      });
      const params = {
        exportType: this.activeTab,
        startTime: this.formEntity.startTime,
        endTime: this.formEntity.endTime,
        merchantIdList: this.formEntity.selectedMerchantId,
        excludeDetailList,
        excludeTotalList,
      };
      // 如果是全部门店，需要遍历获取所有的门店id
      if (this.formEntity.selectedMerchantId[0] === '@') {
        params.merchantIdList = [];
        this.shopList.forEach((v) => {
          if (v.merchantId !== '@') params.merchantIdList.push(v.merchantId);
        });
      }
      // 是否为负号
      if (isNew) params.prefix = 1;
      // 生成文件成功后，立即查询文件列表，这样可以看到刚刚正在生成的文件的状态，让用户知道
      generateExcel(params).then((res) => {
        if (res.data.error_code === 0) {
          this.queryExcelList();
          // 每隔5秒后轮训请求文件列表，看文件导出的状态，如果文件已经生成的话，停止轮训
          this.timer = setInterval(() => {
            this.queryExcelList();
          }, 5000);
        } else {
          this.queryExcelList();
        }
      });
    },
    doShowExportDialog(e, isNew) {
      if (this.isEdit) {
        this.$message.warning("请先保存表头设置");
        return;
      }
      // 判断是否选择了门店
      if (this.formEntity.selectedMerchantId.length === 0) {
        this.$message.error("请选择门店");
      } else {
        this.page.pageNo = 1;
        this.dialogVisible = true;
        this.generateExcel(isNew);
      }
    },
    goShowExportDialog() {
      if (this.isEdit) {
        this.$message.warning("请先保存表头设置");
        return;
      }
      this.dialogVisible = true;
      this.queryExcelList();
      // 每隔5秒后轮训请求文件列表，看文件导出的状态，如果文件已经生成的话，停止轮训
      this.timer = setInterval(() => {
        this.queryExcelList();
      }, 5000);
    },
    closeDialog() {
      clearInterval(this.timer);
    },
    toExportOrder() {
      this.page.pageNo = 1;
      this.dialogVisible = true;
      this.exportAllSummary();
    },
    exportAllSummary() {
      const param = {
        startTime: this.formEntity.startTime && this.formEntity.startTime.substr(0, 10),
        endTime: this.formEntity.endTime && this.formEntity.endTime.substr(0, 10),
      };
      exportAllSummary(param).then((res) => {
        if (res.data.error_code === 0) {
          this.queryExcelList();
          // 每隔5秒后轮训请求文件列表，看文件导出的状态，如果文件已经生成的话，停止轮训
          this.timer = setInterval(() => {
            this.queryExcelList();
          }, 5000);
        } else {
          this.queryExcelList();
        }
      });
    },
  },
  created() {
    this.queryTableHeader();
    this.queryShopList();
    if (JSON.parse(window.localStorage.getItem('LOGIN_INFO'))) {
      this.shopType = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).shopType;
      this.userRole = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).userRole;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss">
.account-container {
  background-color: #f7f7f7;

  .header {
    position: relative;
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .tabs {
    display: flex;
    align-items: center;
    height: 80px;
    padding-left: 50px;
    background-color: #fff;
    border-bottom: 1px solid #f2f3f3;

    .item {
      height: 80px;
      margin-right: 60px;
      font-size: 18px;
      line-height: 80px;
      color: #333;
      cursor: pointer;

      &.active {
        border-bottom: 2px solid #008cff;
      }
    }
  }

  > .content {
    .label {
      width: 80px;
      font-size: 14px;
    }

    > .time {
      padding: 40px 0 20px 50px;
      margin-bottom: 20px;
      background-color: #fff;

      > .el-row {
        margin-bottom: 20px;

        &:last-child {
          padding-top: 20px;
        }

        .el-col {
          .label {
            height: 32px;
            line-height: 32px;
          }
        }
      }

      > .export {
        position: relative;
        top: -80px;
        right: 30px;
        float: right;

        > .export-btn {
          width: auto;
          height: 32px;
          margin-bottom: 10px;
          line-height: 0;
          color: #fff;
          background-color: #008cff;
          border: none;

          &:hover,
          &:focus {
            background-color: #007ee6;
          }
        }

        > p {
          font-size: 14px;
          color: #666;
        }
      }
    }

    .setting {
      position: relative;
      padding-left: 50px;
      background-color: #fff;

      .setting-btn {
        line-height: 0px;
      }

      .tips {
        position: relative;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        width: 92%;
        height: 70px;
        font-size: 18px;
        line-height: 70px;
        color: #333;

        &::after {
          position: absolute;
          right: 0;
          bottom: 0;
          left: -50px;
          display: block;
          height: 0;
          content: "";
          border-bottom: 1px solid #eaeaea;
        }

        .word {
          span {
            display: inline-flex;
            flex-wrap: nowrap;
            font-size: 14px;
            color: #666;
          }
        }

        .btn-group {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: flex-start;

          .el-button {
            height: 32px;
            margin-right: 10px;
            color: #fff;
            background-color: #008cff;
            border: none;

            &:hover,
            &:focus {
              background-color: #007ee6;
            }
          }

          div {
            width: 60px;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }

      .edit-section {
        position: relative;
        margin-right: 10px;

        .mask {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }

        &.edit {
          padding-left: 10px;
          border: 1px solid #008cff;
        }
      }

      .item {
        .title {
          padding-top: 40px;
          padding-bottom: 26px;
          font-size: 18px;
          color: #000;
        }

        .row {
          display: flex;
          flex-wrap: wrap;

          .btn {
            position: relative;
            width: 130px;
            height: 32px;
            margin-right: 20px;
            margin-bottom: 20px;
            line-height: 32px;
            color: #666;
            text-align: center;
            cursor: pointer;
            border: 1px solid #dde0e7;
            border-radius: 2px;

            &.active {
              color: #008cff;
              border: 1px solid #008cff;

              .mark {
                border-right-color: #008cff;
                border-bottom-color: #008cff;
              }
            }

            .mark {
              position: absolute;
              right: 0;
              bottom: 0;
              width: 0;
              height: 0;
              border: 12px solid #dfdfdf;
              border-top-color: transparent;
              border-left-color: transparent;

              i {
                position: absolute;
                font-size: 8px;
                color: #fff;
              }
            }
          }
        }
      }

      > .edit-btn-group {
        margin: 50px auto;
        text-align: center;

        .save-btn {
          width: 120px;
          height: 32px;
          line-height: 0px;
          color: #fff;
          background-color: #008cff;
          border: none;

          &:hover,
          &:focus {
            background-color: #007ee6;
          }
        }

        .cancel-btn {
          width: 120px;
          height: 32px;
          line-height: 0px;

          &:hover,
          &:focus {
            color: #008cff;
            border: 1px solid #008cff;
          }
        }
      }
    }
  }
}

.account-export-dialog-container {
  .el-dialog__header {
    padding: 40px 40px 0;

    .title {
      font-size: 22px;
      color: #333;
    }

    .tips {
      padding-top: 10px;
      font-size: 14px;
      color: #666;
    }
  }

  .el-dialog__body {
    padding: 60px 40px;
    overflow: hidden;
  }
}
</style>
